var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"filled":"","items":_vm.filterOperators,"hide-details":_vm.hideDetails,"label":_vm.$t('selector.operator')},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}})}
var staticRenderFns = []

export { render, staticRenderFns }